import { Channel, ChannelConfiguration } from 'api/notifications';
import { useTranslation } from 'hooks/use-translation';
import { useQuerySlackConfig } from 'queries/slack-integration';

export const channels = Object.values(Channel).map((x) => x as Channel);

export type ChannelEnabled = { enabled: true };
export type ChannelDisabled = { enabled: false; disabledMessage: string };
export type ChannelEnableConfig = ChannelEnabled | ChannelDisabled;

export type ChannelEnabledMap = Record<Channel, ChannelEnableConfig>;

export const useChannels = (): ChannelEnabledMap => {
  const { data } = useQuerySlackConfig();
  const isSlackEnabled = !!(data && data.length > 0);
  const slackDisabledText = useTranslation('notifications.slack.disabled');

  const channelsEnabledMap: ChannelEnabledMap = {
    [Channel.Email]: {
      enabled: true,
    },
    [Channel.InApp]: { enabled: true },
    [Channel.Slack]: {
      enabled: isSlackEnabled,
      disabledMessage: slackDisabledText,
    },
  };

  return channelsEnabledMap;
};

export const empty = Object.values(Channel).reduce(
  (prev, x) => ({ ...prev, [x]: false }),
  {} as ChannelConfiguration,
);
